import { render, staticRenderFns } from "./TabbbedSupport.vue?vue&type=template&id=1994abb0&scoped=true"
import script from "./TabbbedSupport.vue?vue&type=script&lang=js"
export * from "./TabbbedSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994abb0",
  null
  
)

export default component.exports